var map = {
	"./backButton.png": 7951,
	"./connectButton.png": 5538,
	"./farmButton.png": 7642,
	"./houseButton.png": 4188,
	"./inventoryButton.png": 5084,
	"./marketButton.png": 4194,
	"./overworldButton.png": 4834,
	"./statsButton.png": 3965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5153;